import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import resources from '../translations';

const fallbackLanguages = {
    'en-ca': ['en-au', 'en-gb', 'en-us'],
    'en-nz': ['en-au', 'en-gb', 'en-us'],
    'en-au': ['en-gb', 'en-us'],
    'en-ie': ['en-gb', 'en-us'],
    'en-in': ['en-gb', 'en-us'],
    'en-sg': ['en-gb', 'en-us'],
    'en-gb': ['en-us'],
    'fr-be': ['fr-fr', 'en-us'],
    'fr-ca': ['fr-fr', 'en-us'],
    'fr-ch': ['fr-fr', 'en-us'],
    'es-us': ['es-es', 'en-us'],
    'nl-be': ['nl-nl', 'en-us'],
    'de-at': ['de-de', 'en-us'],
    'de-ch': ['de-de', 'en-us'],
    'it-ch': ['it-it', 'en-us'],
    de: ['de-de', 'en-us'],
    fr: ['fr-fr', 'en-us'],
    es: ['es-us', 'en-us'],
    it: ['it-it', 'en-us'],
    ja: ['ja-jp', 'en-us'],
    nl: ['nl-nl', 'en-us'],
    pt: ['pt-br', 'en-us'],
    en: ['en-us'],
    default: ['en-us'],
};

i18n.use(initReactI18next).init({
    resources,
    fallbackLng: fallbackLanguages,
    lowerCaseLng: true, //locales are set to lower case e.g. "en-us" not "en-US"
    interpolation: {
        escapeValue: false,
    },
    nsSeparator: '*****',
    returnObjects: true,
});

// Standalone microfrontends have no language detector — the only `changeLanguage`
// call lives in the SPA client entry (`apps/spa/src/client.tsx`), which is not part
// of a microfrontend bundle. In a per-language microfrontend build the bundle
// contains exactly one locale, so point i18next at it here. Without this, i18next's
// active language stays unset, lookups fall through to the `en-us` fallback, and
// every translation renders in English regardless of the built locale.
if (typeof __MFE_TRANSLATIONS__ !== 'undefined' && __MFE_TRANSLATIONS__) {
    const [bundledLocale] = Object.keys(resources);
    if (bundledLocale) {
        i18n.changeLanguage(bundledLocale);
    }
}

export default i18n;
